import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Shuffle, Loader2 } from "lucide-react";

export const RandomLocalArea = ({ onPick }) => {
  const [busy, setBusy] = useState(false);
  const [info, setInfo] = useState(null);
  const pick = async () => {
    setBusy(true);
    try { const { data } = await api.get("/runs/local-zips", { params: { count: 3 } }); setInfo(data); onPick(data.zips.join(", ")); }
    catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <div className="mt-2" data-testid="random-local-area">
      <Button type="button" variant="outline" size="sm" onClick={pick} disabled={busy} data-testid="random-local-area-btn">
        {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Shuffle className="mr-2 h-4 w-4" />}Random local area
      </Button>
      <p className="mt-1 text-xs text-slate-400" data-testid="random-local-area-info">
        {info ? `Area code ${info.area_code}: ${info.places.join(" · ")} — Ava will call these leads from a local ${info.area_code} number.`
          : "Picks random ZIPs in an area code you have a local calling number for. Click again for a different area."}
      </p>
    </div>
  );
};
